import React, { useState } from "react";
import { Flex, Button, Text, Icon } from "@jsq/ds/core";
import { useDistributionWorkflowContext } from "../../Context/context";
import { DistributionWorkflowStepProps } from "../../types";
import { DistributionBatchesTable } from "./DistributionBatchesTable";
import { container, error, errorIcon, footer, footerButton } from "./styles_vanilla.css";

/**
 * The component for the Select Distribution Batch step in the Distribution Workflow
 *
 * Tests for this component can be found with the DistributionWorkflow component
 */
export const SelectDistributionBatchStep: React.FC<DistributionWorkflowStepProps> = ({
  onBack,
  onContinue,
}: DistributionWorkflowStepProps) => {
  const [showError, setShowError] = useState(false);
  const { distributionBatchId } = useDistributionWorkflowContext();

  const onContinueClick = () => {
    if (distributionBatchId) {
      onContinue();
    } else {
      setShowError(true);
    }
  };

  const onSelectDistributionBatch = () => {
    setShowError(false);
  };

  return (
    <Flex className={container} flexDirection="column">
      <Text variant="h2" marginBottom="lg">
        Distributions
      </Text>
      <DistributionBatchesTable onSelectDistributionBatch={onSelectDistributionBatch} />
      <Flex className={footer} justifyContent="space-between">
        <Flex>
          <Button onClick={onBack} variant="neutral" className={footerButton}>
            Back
          </Button>
        </Flex>
        <Flex>
          {showError && (
            <Flex alignItems="center" className={error}>
              <Icon className={errorIcon} type="exclamation-circle" />
              You must select a distribution to continue
            </Flex>
          )}
          <Flex>
            <Button onClick={onContinueClick} className={footerButton}>
              Continue
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SelectDistributionBatchStep;
